import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { BillingStatusPendingReviewModal } from 'components/modules/shipments/BillingStatusPendingReviewModal';
import { PENDING_REVIEW } from 'constants/billing-status';

export const BillingStatusPendingReviewEditor = forwardRef(
  ({ stopEditing, data, node }, ref) => {
    const {
      shipment_oid,
      billing_status_state_billing_status,
      billing_status_state_pause_automated_billing_evaluation_reason_code,
      billing_status_state_pause_automated_billing_evaluation_reason_codes,
    } = data;
    const [open, setOpen] = useState(true);
    const [value, setValue] = useState(
      billing_status_state_pause_automated_billing_evaluation_reason_codes,
    );

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });

    function handleSuccess(payload) {
      const update = payload[0];
      const updatedReasonCodes =
        update.billing_status_state_pause_automated_billing_evaluation_reason_codes;
      setValue(updatedReasonCodes);
      node.updateData({
        ...data,
        ...update,
      });
      stopEditing();
      setOpen(false);
    }

    function handleHide() {
      stopEditing();
      setOpen(false);
    }

    return (
      <BillingStatusPendingReviewModal
        open={open}
        onHide={handleHide}
        onSuccess={handleSuccess}
        reasonCodes={value}
        showStatusToggle={
          billing_status_state_billing_status === PENDING_REVIEW
        }
        shipmentIds={[shipment_oid]}
        note={
          billing_status_state_pause_automated_billing_evaluation_reason_code
        }
      />
    );
  },
);
